module.exports = __webpack_public_path__ + "img/thumbsup.a7116369.png";